import * as Sentry from "@sentry/react";
import TagManager from "react-gtm-module";

import { getLocalStorageItem } from "./storageLib";

export const analytics = {
	init: async () => {
		try {
			Sentry.init({
				dsn: process.env.REACT_APP_SENTRY_DNS,
				environment: process.env.REACT_APP_ENV,
			});
		} catch (err) {
			// should only error in dev without ids
		}

		try {
			TagManager.initialize({
				gtmId: process.env.REACT_APP_GTM_ID,
			});
		} catch (err) {
			// should only error in dev without ids
		}
	},
	registerProperties: async (props = {}) => {
		analytics.event("registerProperties", {
			properties: JSON.stringify(props),
		});
	},
	clearSession: async () => {
		return new Promise((resolve, reject) => {
			let ready = {
				sentry: false,
			};

			const isReady = () => {
				if (!ready.sentry) {
					return;
				}

				resolve();
			};

			const clearSentry = () => {
				try {
					Sentry.close(2000).then((e) => {
						console.log("sentry", e);
					});
				} catch (err) {
					console.log(err);
				}
				ready.sentry = true;
				isReady();
			};

			clearSentry();
		});
	},
	setIdentity: async (userAttributes) => {
		try {
			analytics.event("setIdentity", {
				properties: JSON.stringify(userAttributes),
			});
		} catch (err) {}
	},
	clearIdentity: async () => {
		try {
			analytics.event("clearIdentity");
		} catch (err) {}
	},
	event: (name, props = {}) => {
		let data = {
			event: name,
			eventProps: props,
		};

		const gaClientId = getLocalStorageItem("gaClientId", null);
		if (gaClientId) {
			data.clientId = gaClientId;
		}

		window.dataLayer.push(data);
	},
};
